import React, {FunctionComponent, ReactElement, useCallback, useEffect, useRef, useState} from "react";
import {QueryClient, QueryClientProvider} from "react-query";

import {
    ACard,
    ADataGrid, ADataGridColors,
    ADataGridColumn,
    ADataGridFilter,
    PagedSearchParams,
} from "@atiautomacao/ati-ui-library";

import { extractFiltersFromColumns } from "../../../../Utils/DataUitils";
import { RootState } from "../../../../Config/Store";
import { useAppDispatch, useAppSelector } from "../../../../Config/Hooks";
import {searchEntities, Alarm, clear} from "./AlarmPowerPlantReducer";
import IconButton from "@mui/material/IconButton";
import {BorderColor, FactCheck, FilterAltOutlined} from "@mui/icons-material";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import {isArray} from "lodash";
import {DateFormat} from "../../../../Utils/DateFormatPatternUtils";
import {Badge, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link, Modal,useTheme} from "@mui/material";
import AlarmGroup from "./Components/AlarmGroup";

import {usePowerStationNavigation} from "../../../../Shared/Hooks/usePowerStationNavigation";
import {useSkidNavigation} from "../../../../Shared/Hooks/useSkidNavigation";
import {alarmSearchGroup, checkGroupingType, getAlarmDisplayLabel, handleOnColor} from "../../../../Utils/AlarmsService";
import {useSnackbar} from "notistack";
import AlarmNotion from "../../Alarms/Components/AlarmNotion";
import {alarmAcknowledge, alarmFinalize, AlarmActionArgs} from "../../Alarms/AlarmReducer";
import {Storage} from "../../../../Utils/StorageUtils";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Tooltip from "@mui/material/Tooltip";
import CancelIcon from "@mui/icons-material/Cancel";
import useInterval from "../../../../Shared/Hooks/useInterval";
import { hasPermission } from "../../../../Shared/Auth/AuthenticationUtil";
import { AUTHORITIES } from "../../../../Config/Constants";
import {useEquipmentNavigation} from "../../../../Shared/Hooks/useEquipmentNavigation";
import {useEquipmentWithoutSkidNavigation} from "../../../../Shared/Hooks/useEquipmentWithoutSkidNavigation";
import {TicketUpdateModal} from "../../Ticket/TicketModal";
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { LoadingButton } from "@mui/lab";
import { mergeAndDeduplicateFilters } from "../../../../Utils/FilterMergeUtils";
import {
    applyFiltersToAlarmColumns,
    buildAlarmDateFilterSanitizationMessage,
    buildAlarmDateFilterValidationMessage,
    processAlarmDateFilters,
} from "../../../../Utils/AlarmDateFilterValidationUtils";

export const initColumnsData = [
    {
        name: 'id',
        label: 'ID',
        align: 'left',
        visibility: false,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'severityName',
        label: 'severidade',
        align: 'left',
        minWidth: '1vw',
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'description',
        label: 'descrição',
        align: 'left',
         minWidth: '15vw',
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'macroRegionName',
        label: 'macro',
        align: 'left',
        visibility: false,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'regionName',
        label: 'região',
        align: 'left',
        visibility: false,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'skidName',
        label: 'skid',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'equipmentName',
        label: 'equipamento',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'dateTime',
        label: 'início',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "dateTime",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'clearDate',
        label: 'finalizado',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "clearDate",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'acknowledgementDate',
        label: 'reconhecido',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "acknowledgementDate",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'userName',
        label: 'usuário',
        align: 'left',
        visibility: true,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
] as ADataGridColumn[]

export type ActionConfig = {
    actionName: string;
    disabled: boolean;
    props?: any;
}

export interface AlarmRow {
    id: string;
    teleObjectId: number;
    teleObjectInhibited: boolean;
    severityId: number;
    severityName: string | ReactElement;
    severityColor: string;
    description: string;
    macroRegionName: string;
    regionName: string;
    powerStationId: number;
    powerStationName: string | ReactElement;
    skidId: number;
    skidName: string | ReactElement;
    equipmentId: number;
    equipmentName: string | ReactElement;
    clearDate?: Date | string;
    acknowledgementDate?: Date | string;
    dateTime: Date | string;
    userName: string;
    group: boolean | any;
    hasAlarmSound: boolean;
    totalTickets?: number | null;
    actionsConfig?: Array<ActionConfig>

}

const POWER_STATION_ALARM_PAGE_SIZE_KEY = 'power-station-alarm-page-size';
const DEFAULT_PAGE_SIZE = 20;

const getInitialPageSize = (): number => {
    const storedSize = Number(Storage.local.get(POWER_STATION_ALARM_PAGE_SIZE_KEY, DEFAULT_PAGE_SIZE));
    if (Number.isFinite(storedSize) && storedSize > 0) {
        return storedSize;
    }
    return DEFAULT_PAGE_SIZE;
}

const AlarmPage:FunctionComponent<{powerPlantId:number, advancedFilters:ADataGridFilter[] | null, hasClearFilters: (hasClearFilters: boolean) => void}> = ({powerPlantId, advancedFilters, hasClearFilters}) => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const queryClient = new QueryClient();
    const [firstLoad, setFirstLoad] = useState(true);

    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToAcknowledge = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.DASHBOARD_POWER_STATION_ALARM_ACKNOWLEDGE
    ]);

    const isAuthorizedToFinalize = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.DASHBOARD_POWER_STATION_ALARM_FINALIZE
    ]);

      const isAuthorizedToTicketSave = hasPermission(account?.authoritySet, [
          AUTHORITIES.SYSADMIN, 
          AUTHORITIES.SAVE_TICKET
      ]);
  
      const isAuthorizedToTicketSearch = hasPermission(account?.authoritySet, [
          AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_TICKET, AUTHORITIES.VIEW_TICKET
      ]);
  
      const isAuthorizedToTicketCategorySearch = hasPermission(account?.authoritySet, [
          AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_TICKET_CATEGORY, AUTHORITIES.VIEW_TICKET_CATEGORY
      ]);
  
      const isAuthorizedToTicketSubCategorySearch = hasPermission(account?.authoritySet, [
          AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_TICKET_SUBCATEGORY, AUTHORITIES.VIEW_TICKET_SUBCATEGORY
      ]);
  
      const isAuthorizedToView = () => {
  
          if(isAuthorizedToTicketSave && isAuthorizedToTicketSearch && isAuthorizedToTicketCategorySearch && isAuthorizedToTicketSubCategorySearch ){
              return true;
          }
          return false;
      
      }

    const isLoading = useAppSelector((state : RootState) => state.alarmPowerPlant.loading);
    const totalOfRecords = useAppSelector((state : RootState) => state.alarmPowerPlant.totalOfRecords);
    const entities: Array<Alarm> = useAppSelector((state: RootState) => state.alarmPowerPlant.entities);

    const navigationToPowerStation = usePowerStationNavigation();
    const navigationToSkid = useSkidNavigation();
    const navigationToEquipment = useEquipmentNavigation();
    const navigationToEquipmentWithoutSkid = useEquipmentWithoutSkidNavigation();


    const [rows, setRows] = useState<Array<AlarmRow>>([]);
    const [columns, setColumns] = useState<Array<ADataGridColumn>>(
        applyFiltersToAlarmColumns(initColumnsData, extractFiltersFromColumns(initColumnsData))
    );
    const [currentDataGridFilters, setCurrentDataGridFilters] = useState<Array<ADataGridFilter>>(
        extractFiltersFromColumns(initColumnsData)
    );

    const [pagedSearchParams, setPagedSearchParams] = useState(
        new PagedSearchParams(
            extractFiltersFromColumns(initColumnsData),
            0,
            getInitialPageSize()
        )
    );
    const [open, setOpen] = React.useState(false);
    const [notionOpen, setNotionOpen] = React.useState(false);
    const [groupOpen, setGroupOpen] = React.useState(false);
    const [entityToModel, setEntityToModel] = useState<object>();
    const [selectedRows, setSelectedRows] = useState<any>();
    const [selectedAlarmForTicket, setSelectedAlarmForTicket] = useState<any>();
    const [hasAlarmSound, setHasAlarmSound] = useState(false);
    const [activeAdvancedFilters, setActiveAdvancedFilters] = useState<ADataGridFilter[] | null>(advancedFilters);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [acknowledgeDialog, setAcknowledgeDialog] = useState(false);
    const userConfig = useAppSelector((state: RootState) => state.userConfigurarion);

    const [openTicketModal, setOpenTicketModal] = useState(false);

    // Sincroniza filtros avançados quando mudam
    useEffect(() => {
        setActiveAdvancedFilters(advancedFilters);
    }, [advancedFilters]);

    // Quando filtros avançados ou do DataGrid mudam, atualiza pagedSearchParams
    useEffect(() => {
        const mergedFilters = mergeAndDeduplicateFilters(currentDataGridFilters, activeAdvancedFilters, currentDataGridFilters);
        setPagedSearchParams((current) => {
            // Só atualiza se os filtros realmente mudaram
            if (JSON.stringify(current.filters) !== JSON.stringify(mergedFilters)) {
                return new PagedSearchParams(mergedFilters, 0, current.size);
            }
            return current;
        });
    }, [activeAdvancedFilters, currentDataGridFilters]);

    const handleOnRowOpen = useCallback(async (data: any) => {
        if(data && !isArray(data)){
            setGroupOpen(true);
            let params = new PagedSearchParams(extractFiltersFromColumns(initColumnsData), 0, 20)
            // Inclui powerStationId obrigatoriamente
            params.filters.push({name: 'powerStationId', condition: 'equals', value: data.powerStationId.toString(), sort: 'none'},)
            params.filters.push(...checkGroupingType(data))
            try {
                const hasGroup = await alarmSearchGroup(params);
                if(!hasGroup){
                    enqueueSnackbar("Sem dados agrupados!", {variant: 'warning'})
                } else {
                    setEntityToModel(data)
                    setOpen(true);
                }
            } catch (error) {
                console.error(error);
            }
        }else {
            setOpen(false);
        }
    }, []);

    const handleOnNotionOpen = useCallback(async (data: any) => {
        if(data && !isArray(data)) {
            setNotionOpen(true);
            setEntityToModel(data);
            setOpen(true);
        }
    }, []);

    const handleCloseModal = () => {
        setOpen(false);
        setGroupOpen(false);
        setNotionOpen(false);
    };

    const showAlarmDateFilterSanitizationMessage = (fieldLabels: Array<string>) => {
        enqueueSnackbar(buildAlarmDateFilterSanitizationMessage(fieldLabels), {variant: 'warning'});
    };

    const showAlarmDateFilterValidationMessage = (fieldLabels: Array<string>) => {
        enqueueSnackbar(buildAlarmDateFilterValidationMessage(fieldLabels), {variant: 'error'});
    };

    const validatePagedSearchParams = (params: PagedSearchParams, showMessage = true): PagedSearchParams | null => {
        const processedResult = processAlarmDateFilters(params.filters);

        if (processedResult.wasSanitized) {
            if (showMessage) {
                showAlarmDateFilterSanitizationMessage(processedResult.sanitizedFieldLabels);
            }
            return null;
        }

        if (!processedResult.isValid) {
            if (showMessage) {
                showAlarmDateFilterValidationMessage(processedResult.invalidFieldLabels);
            }
            return null;
        }

        return new PagedSearchParams(processedResult.convertedFilters, params.page, params.size);
    };

    const finalizeAlarms = useCallback(async () => {
        handleClose()
        if(isArray(selectedRows)){
            const rowSelected = selectedRows.filter((row) => row.selected)
            const params:AlarmActionArgs = {
                alarmsListId: rowSelected.map((row) => Number(row.data.id))
            }
            const actionResult = await dispatch(alarmFinalize(params))
            if(alarmFinalize.fulfilled.match(actionResult)){
                dispatch(clear());
                const validatedParams = validatePagedSearchParams(pagedSearchParams, false);
                if (validatedParams) {
                    dispatch(searchEntities({params: ensurePowerStationIdInFilters(validatedParams)}))
                }
            }
        }else if(selectedRows){
            const actionResult = await dispatch(alarmFinalize({alarmsListId: [Number(selectedRows.id)]}))
            if(alarmFinalize.fulfilled.match(actionResult)){
                dispatch(clear());
                const validatedParams = validatePagedSearchParams(pagedSearchParams, false);
                if (validatedParams) {
                    dispatch(searchEntities({params: ensurePowerStationIdInFilters(validatedParams)}))
                }
            }
        }
    },[selectedRows]);


    const alarmAcknowledges = useCallback(async() => {
        handleClose()
        if(isArray(selectedRows)){
            const rowSelected = selectedRows.filter((row) => row.selected)
            const params:AlarmActionArgs = {
                alarmsListId: rowSelected.map((row) => Number(row.data.id))
            }
            const actionResult = await dispatch(alarmAcknowledge(params))
            if(alarmAcknowledge.fulfilled.match(actionResult)){
                dispatch(clear());
                const validatedParams = validatePagedSearchParams(pagedSearchParams, false);
                if (validatedParams) {
                    dispatch(searchEntities({params: ensurePowerStationIdInFilters(validatedParams)}))
                }
            }
        }else if(selectedRows){
            const actionResult = await dispatch(alarmAcknowledge({alarmsListId: [Number(selectedRows.id)]}))
            if(alarmAcknowledge.fulfilled.match(actionResult)){
                dispatch(clear());
                const validatedParams = validatePagedSearchParams(pagedSearchParams, false);
                if (validatedParams) {
                    dispatch(searchEntities({params: ensurePowerStationIdInFilters(validatedParams)}))
                }
            }
        }
    },[selectedRows]);

    const handleCleanFilters = () => {
        setActiveAdvancedFilters([]);
        const newPagedSearchParams = new PagedSearchParams([], 0, pagedSearchParams.size);
        setColumns(applyFiltersToAlarmColumns(initColumnsData, []));
        setCurrentDataGridFilters(newPagedSearchParams.filters);
        setPagedSearchParams(newPagedSearchParams);
        hasClearFilters(true);
    }

    const handleOnFiltersChange = useCallback((dataGridFilters: Array<ADataGridFilter>, page: number, pageSize: number) => {
        Storage.local.set(POWER_STATION_ALARM_PAGE_SIZE_KEY, pageSize);
        const processedResult = processAlarmDateFilters(dataGridFilters);

        // Sync columns only when sanitization changed values — avoids ADataGrid onFiltersChange loop
        if (processedResult.wasSanitized) {
            setColumns(applyFiltersToAlarmColumns(initColumnsData, processedResult.filters));
            showAlarmDateFilterSanitizationMessage(processedResult.sanitizedFieldLabels);
            return;
        }

        if (!processedResult.isValid) {
            showAlarmDateFilterValidationMessage(processedResult.invalidFieldLabels);
            return;
        }

        setCurrentDataGridFilters(processedResult.filters);

        const mergedFilters = mergeAndDeduplicateFilters(processedResult.filters, activeAdvancedFilters, processedResult.filters);
        setPagedSearchParams(new PagedSearchParams(mergedFilters, page, pageSize));
    }, [activeAdvancedFilters]);

    useInterval(() => {
        if (!isLoading) {
            const validatedParams = validatePagedSearchParams(pagedSearchParams, false);

            if (validatedParams) {
                dispatch(searchEntities({params: ensurePowerStationIdInFilters(validatedParams)}));
            }
        }
    }, userConfig.alarmUpdateInterval, undefined, isLoading); //1 minute after the latest search finishes
    const handleNavigationPowerPlant = (event:  React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.MouseEvent<HTMLSpanElement, MouseEvent>, powerPlantId: number): void => {
        event.preventDefault();
        navigationToPowerStation(powerPlantId);
    }

    const handleNavigationSkid = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.MouseEvent<HTMLSpanElement, MouseEvent>, powerStationId: number, skidId: number): void => {
        event.preventDefault();
        navigationToSkid(powerStationId, skidId);
    }

    const handleNavigationEquipmentPage = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.MouseEvent<HTMLSpanElement, MouseEvent>, powerPlantId: number, skidId: number | null, equipmentId: number): void => {
        event.preventDefault();
        if(powerPlantId != null && skidId != null){
            navigationToEquipment(equipmentId);
        } else {
            navigationToEquipmentWithoutSkid(equipmentId);
        }

    }



    const handleClickOpen = (rows:any) => {
        if(isAuthorizedToFinalize) {
            setSelectedRows(rows);
            setDialogOpen(true);
        } else {
            enqueueSnackbar("Você não está autorizado à acessar essa funcionalidade", {
                variant: 'warning',
            });
            return null;
        }
        
    };

    const handleOpenTicketModal = (rows:any) => {
        if(!isAuthorizedToView()){
            enqueueSnackbar("Você não está autorizado à acessar essa funcionalidade", {
                variant: 'warning',
            });
            return null;
        }
        setSelectedAlarmForTicket(rows);
        setOpenTicketModal(true);
    }

    const handleCloseTicketModal = () => {
        setSelectedAlarmForTicket(null);
        setOpenTicketModal(false);
    }

    const handleAcknowledgeClick = (rows:any) => {
        if(isAuthorizedToAcknowledge) {
            setSelectedRows(rows);
            setAcknowledgeDialog(true)
        } else {
            enqueueSnackbar("Você não está autorizado à acessar essa funcionalidade", {
                variant: 'warning',
            });
            return null;
        }
        
    }

    const handleClose = () => {
        setDialogOpen(false);
        setAcknowledgeDialog(false);
    };

    const structureRow = (entitiesValues: Array<Alarm>) => {
        let newHasAlarmSound = false;
        let alarms: Array<AlarmRow> = []
        entitiesValues.forEach( alarm => {
            alarms.push({
                teleObjectId: alarm.teleObjectId,
                teleObjectInhibited: alarm.teleObjectInhibited,
                id: alarm.id.toString(),
                group: alarm.group,
                severityId: alarm.severityId,
                severityName: alarm.teleObjectInhibited
                    ? getAlarmDisplayLabel(alarm)
                    : (alarm?.clearDate == null || alarm?.clearDate.length < 1) && (alarm?.acknowledgementDate == null || alarm?.acknowledgementDate.length < 1) && alarm.hasAlarmSound ?
                    <>
                        <VolumeUpIcon fontSize="small" sx={{ verticalAlign: 'middle', marginRight: 0.5, color: theme.palette.primary.main }}/>
                        {alarm.severityName}
                    </> : alarm.severityName,
                severityColor: alarm.severityColor,
                description: alarm.description,
                macroRegionName: alarm.macroRegionName,
                regionName: alarm.regionName,
                powerStationId: alarm.powerStationId,
                powerStationName: <Link href="#" onClick={(event) => handleNavigationPowerPlant(event, alarm.powerStationId)} underline="hover">{alarm.powerStationName}</Link>,
                skidId: alarm.skidId,
                skidName:<Link href="#" onClick={(event) => handleNavigationSkid(event, alarm.powerStationId, alarm.skidId)} underline="hover">{alarm.skidName}</Link>,
                equipmentId: alarm.equipmentId,
                equipmentName: <Link href="#" onClick={(event) => handleNavigationEquipmentPage(event, alarm.powerStationId, alarm.skidId, alarm.equipmentId)}>{alarm.equipmentName}</Link>,                clearDate: alarm.clearDate ? DateFormat(alarm.clearDate) : "",
                acknowledgementDate: alarm.acknowledgementDate ? DateFormat(alarm.acknowledgementDate) : "",
                dateTime: DateFormat(alarm.dateTime),
                userName: alarm.userName,
                hasAlarmSound: alarm.hasAlarmSound,
                totalTickets: alarm.totalTickets,
                actionsConfig: [
                    {actionName: "grouping", disabled: false},
                    {actionName: "note", disabled: false},
                    {actionName: "acknowledge", disabled: isAuthorizedToAcknowledge ? (alarm.acknowledgementDate != null) : true},
                    {actionName: "finalize", disabled: isAuthorizedToFinalize ? (alarm.clearDate != null) : true},
                    {actionName: "ticket", disabled: !isAuthorizedToView(), props: { badgeContent: alarm.totalTickets }}
                ],
            });
            if( (alarm?.clearDate == null || alarm?.clearDate.length < 1) && (alarm?.acknowledgementDate == null || alarm?.acknowledgementDate.length < 1) && alarm?.hasAlarmSound === true && !newHasAlarmSound){
                newHasAlarmSound = true;
            }
        });
        setHasAlarmSound(newHasAlarmSound);
        setRows(alarms);
    }

    const alarmSound = async () => {
        const audio = new Audio(process.env.PUBLIC_URL + "/notification_02.mp3");
        audio.volume = 0.7;
        const audioMuted = localStorage.getItem("audioMuted") === "true";
        try {
            await new Promise((resolve) => {

                audio.onended = resolve;
                audio.oncanplay = () => {

                    audio.muted = !audioMuted;
                    if(audioMuted){
                        audio.play();
                    }
                };
            });
        } catch (err) {
            console.log("error", err);
        }
    }

    // Effects
    const columnsRef = useRef(false);
    const paramsRef = useRef(false);
    const pendingSearchRef = useRef(false);

    const ensurePowerStationIdInFilters = (params: PagedSearchParams): PagedSearchParams => {
        const hasPowerStationId = params.filters.some(f => f.name === 'powerStationId');

        if (!hasPowerStationId) {
            // Adiciona powerStationId como primeiro filtro
            return new PagedSearchParams(
                [
                    { name: 'powerStationId', condition: 'equals', value: powerPlantId.toString(), sort: 'none' },
                    ...params.filters
                ],
                params.page,
                params.size
            );
        } else {
            // Verifica se o valor está correto (pode ter sido alterado se powerPlantId mudou)
            const updatedFilters = params.filters.map(f =>
                f.name === 'powerStationId' && f.value !== powerPlantId.toString()
                    ? { ...f, value: powerPlantId.toString() }
                    : f
            );
            return new PagedSearchParams(updatedFilters, params.page, params.size);
        }
    };

    useEffect(() => {
        if(paramsRef.current) {
            const validatedParams = validatePagedSearchParams(pagedSearchParams);

            if (!validatedParams) {
                return;
            }
            if (isLoading) {
                pendingSearchRef.current = true;
                return;
            }

            pendingSearchRef.current = false;

            const safeParams = ensurePowerStationIdInFilters(validatedParams);
            dispatch(searchEntities({params: safeParams}));
        } else {
            paramsRef.current = true;
        }
    }, [powerPlantId, pagedSearchParams]);

    useEffect(() => {
        if (hasAlarmSound) {
            const intervalo = setInterval(() => {
                alarmSound();
            }, 2000);

            return () => clearInterval(intervalo);
        }
    },[hasAlarmSound]);

    useEffect(() => {
        if(!columnsRef.current){
            columnsRef.current = true;
        }
    },[initColumnsData]);

    useEffect(() => {
        if (isArray(entities) && entities.length > 0) {
            structureRow(entities);
        }else {
            setRows([]);
            setHasAlarmSound(false);
        }
        setFirstLoad(false);
    }, [entities]);

    const newHandleOnColor = (data: any, columnItem: any): ADataGridColors => {
        return handleOnColor(data,columnItem,theme);
    }

    return (
        <QueryClientProvider client={queryClient}>
            <ACard ariaLabel={"power-station-alarm"}
                styleProps={{
                    cardStyle: {cursor: isLoading ? 'wait' : 'default', boxShadow: 'none'},
                    contentStyle: { padding: '0 0px 10px 0' },
                }}
                headerControls={
                    <LoadingButton
                        variant="text"
                        color="primary"
                        onClick={handleCleanFilters}
                        endIcon={<FilterAltOutlined />}
                        disabled={isLoading}
                    >
                        Limpar filtros
                        </LoadingButton>

                }
            >
                <ADataGrid
                    noMaxHeight
                    hideFilters={false}
                    showFilterOptions={false}
                    hideSelection={false}
                    size={"small"}
                    columns={columns}
                    rows={rows}
                    page={pagedSearchParams.page}
                    loading={isLoading && firstLoad}
                    totalOfRecords={totalOfRecords || 0}
                    rowsPerPage={pagedSearchParams.size}
                    onFiltersChange={handleOnFiltersChange}
                    onColorSelect={newHandleOnColor}
                    actionColumnWidth={210}
                    actionColumnStyle={{minWidth: 200}}
                    disableActionsHeaderIcons={false}
                    actions={
                        <>
                            <IconButton {...({ disableHeader: true } as any)} name="grouping" size={"small"} aria-label="Fact check" onClick={handleOnRowOpen}>
                                <Tooltip title="Agrupamento">
                                    <FactCheck/>
                                </Tooltip>
                            </IconButton>

                            <IconButton {...({ disableHeader: true } as any)} name="note" size={"small"} aria-label="Border color" onClick={handleOnNotionOpen}>
                                <Tooltip title="Adicionar nota">
                                    <BorderColor />
                                </Tooltip>
                            </IconButton>
                            <IconButton name="acknowledge" size={"small"} aria-label="Fact check" onClick={handleAcknowledgeClick} disabled={!isAuthorizedToAcknowledge}>
                                <Tooltip title="Reconhecer alarme">
                                    <CheckCircleIcon />
                                </Tooltip>
                            </IconButton>
                            <IconButton name="finalize" size={"small"} aria-label="Border color" onClick={handleClickOpen} disabled={!isAuthorizedToFinalize}>
                                <Tooltip title="Finalizar alarme">
                                    <CancelIcon />
                                </Tooltip>
                            </IconButton>
                            <Badge color="secondary" {...({ disableHeader: true } as any)} name="ticket" onClick={handleOpenTicketModal} invisible={!isAuthorizedToView()}>
                                <IconButton size={"small"} aria-label="Border color" disabled={!isAuthorizedToView()}>
                                    <Tooltip title="Tickets">
                                        <ConfirmationNumberIcon />
                                    </Tooltip>
                                </IconButton>
                            </Badge>
                        </>
                    }
                />
                <Modal
                    open={open}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"

                >
                    { groupOpen && !notionOpen ?
                        <AlarmGroup alarm={entityToModel} />
                        :
                        <AlarmNotion alarm={entityToModel} />
                    }
                </Modal>
                <Dialog open={dialogOpen || acknowledgeDialog} onClose={handleClose}>
                    <DialogTitle>{`Confirmar ${dialogOpen ? 'finalização' : 'reconhecimento'}`}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Tem certeza de que deseja {dialogOpen ? 'finalizar' : 'reconhecer'} este alarme?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancelar</Button>
                        <Button onClick={dialogOpen ? finalizeAlarms : alarmAcknowledges} autoFocus>
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Ticket Modal */}
                <TicketUpdateModal
                    alarm={openTicketModal ? selectedAlarmForTicket : null}
                    open={openTicketModal}
                    onClose={handleCloseTicketModal}
                    canQueryTickets={isAuthorizedToView()}
                />
            </ACard>
        </QueryClientProvider>
    )
}

export default AlarmPage;
